// extracted by mini-css-extract-plugin
export var addToCartButton = "_qs-b";
export var arrowButtonContainer = "_qs-9";
export var arrowButtonIcon = "_qs-a";
export var carouselArrowButton = "_qs-6";
export var carouselElementContainer = "_qs-1";
export var left = "_qs-7";
export var productDisplayCarouselContainer = "_qs-0";
export var productTileContainer = "_qs-2";
export var productTileImage = "_qs-4";
export var productTileImageContainer = "_qs-3";
export var productTileTitle = "_qs-5";
export var right = "_qs-8";
export var sliderOverflow = "_qs-c";